export enum LoginProvider {
  Cxm = 'cxm',
  Google = 'google',
  Facebook = 'facebook',
  Tiendanube = 'tiendanube',
  Meli = 'meli',
}
